export enum Role {
    Admin="ALISS-ADMIN",
    MenuConfigurator = 'ALISS-MENU-CONF',
    MenuAdministrator = 'ALISS-MENU-ADMI',
    Anyone = '*',
}